import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotifsAndMessagesService {
  private baseUrl: string = environment.baseApi;

  constructor(private http: HttpClient) {}
  getMessages(page: number = 1, lastFetchedId: number = undefined) {
    return this.http.get(`${this.baseUrl}messages/`, {
      params: {
        page: page,
      },
    });
  }

  getNotifications(page: number = 1, lastFetchedId: number = undefined) {
    return this.http.get(`${this.baseUrl}notifications/`, {
      params: {
        page: page,
      },
    });
  }

  markNotificationAsSeen(id: number) {
    return firstValueFrom(
      this.http.patch(`${this.baseUrl}notifications/see/${id}/`, {}),
    );
  }

  deleteNotification(id: number) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}notifications/delete/${id}/`),
    );
  }

  deleteAllNotifications(lastFetchedId: number) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}notifications/delete-all/`, {
        body: { last_fetched_id: lastFetchedId },
      }),
    );
  }

  seeAllNotifications(lastFetchedId: number) {
    return firstValueFrom(
      this.http.patch(`${this.baseUrl}notifications/see-all/`, {
        last_fetched_id: lastFetchedId,
      }),
    );
  }

  markMessageAsSeen(id: number) {
    return firstValueFrom(
      this.http.patch(`${this.baseUrl}messages/see/${id}/`, {}),
    );
  }

  deleteMessage(id: number) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}messages/delete/${id}/`),
    );
  }

  deleteAllMessages(lastFetchedId: number) {
    return firstValueFrom(
      this.http.delete(`${this.baseUrl}messages/delete-all/`, {
        body: { last_fetched_id: lastFetchedId },
      }),
    );
  }

  seeAllMessages(lastFetchedId: number) {
    return firstValueFrom(
      this.http.patch(`${this.baseUrl}messages/see-all/`, {
        last_fetched_id: lastFetchedId,
      }),
    );
  }

  getMessageById(id: number) {
    return firstValueFrom(this.http.get(`${this.baseUrl}messages/${id}/`));
  }
}
/**
 * ###

GET {{ROOT}}/messages/
Authorization: Bearer {{auth_token}}

###
DELETE {{ROOT}}/messages/delete/3018/
Authorization: Bearer {{auth_token}}

###
DELETE {{ROOT}}/messages/delete-all/
Authorization: Bearer {{auth_token}}
Content-Type: application/json

{
    "last_fetched_id": 3017
}

###
PATCH {{ROOT}}/messages/see/3017/
Authorization: Bearer {{auth_token}}


###
PATCH {{ROOT}}/messages/see-all/
Authorization: Bearer {{auth_token}}
Content-Type: application/json

{
    "last_fetched_id": 3017
}

###
GET {{ROOT}}/messages/3019/
Authorization: Bearer {{auth_token}}
Content-Type: application/json




 */
